import api from './client.js'

export const userAdminAPI = {
  previewImport:  ()            => api.get('/user-admin/import/preview', { timeout: 30_000 }),
  // Voor 100+ users met bcrypt-hash duurt de import makkelijk langer dan de
  // 10s default. Lange timeout zodat de client wacht tot de backend echt klaar
  // is; nginx staat op 300s dus we blijven binnen die marge.
  runImport:      (opts = {})   => api.post('/user-admin/import/run', {
    sync_ids: opts.sync_ids,
    names:    opts.names,
  }, { timeout: 180_000 }),
  resetPassword:  (id)          => api.post(`/user-admin/${id}/reset-password`),
  setRfid:        (id, rfid)    => api.post(`/user-admin/${id}/rfid`, { rfid }),
  changePassword: (current, next) =>
    api.post('/user-admin/change-password', { current_password: current, new_password: next }),
}
